<template>
  <div>
    <div class="full">
      <div class="full">
        <div class="mainheader">
           {{ $t('employee.contract.contractHeader') }}
        </div>
      </div>

      <div v-if="loading" class="label left">
        <i class="fas fa-circle-notch fa-spin"></i> {{ ' ' + $t('employee.collective.pleaseWait') }}<br/>
        {{ ' ' + $t('employee.contract.documentsLoading') }}<br/>
      </div>
      <div style="margin-top: 15px" class="full first">
        <div class="header">
          <div class="label">{{ $t('employee.contract.activeContracts') }}</div>
          <div v-if="currentEmployeeContractStores.length > 1">
            <div v-for="storeId in currentEmployeeContractStores" :key="storeId"
                class="button small" :class="{'ml': selectedContractStoreId == storeId}" @click="selectedContractStoreId = storeId"
                style="margin-right: 5px; height: 22px" :style="{color: selectedContractStoreId == storeId ? 'white' : ''}">
              {{ stores.find(s => s.id == storeId) ? stores.find(s => s.id == storeId).name : storeId }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="employeeContract" class="full">
        <div class="third left">
          <div class="full">
            <div class="third left">
              <div class="label">{{ $t('employee.contract.job') }}</div>
            </div>
            <div class="twothirds right">
              <div class="label data">{{ employeeContract.jobName }}</div>
            </div>
          </div>
          <div class="full split-bottom-tight">
            <div class="third left">
              <div class="label">{{ $t('employee.contract.category') }}</div>
            </div>
            <div class="twothirds right">
              <div class="label data">{{ employeeCategoryMap[employeeContract.employeeCategory] }}</div>
            </div>
          </div>
          <div class="full" v-bind:class="{'split-bottom-tight': !employeeContract.costCenterId}">
            <div class="third left">
              <div class="label">{{ $t('comp.ui.store') }}</div>
            </div>
            <div class="twothirds right">
              <div class="label data">{{ getStoreInfoString(employeeContract.storeId) }}</div>
            </div>
          </div>
          <div v-if="employeeContract.costCenterId" class="full split-bottom-tight">
            <div class="third left">
              <div class="label">{{ $t('comp.ui.costCenter') }}</div>
            </div>
            <div class="twothirds right">
              <div class="label data">{{ getCostCenterInfoString(employeeContract.costCenterId) }}</div>
            </div>
          </div>
          <div class="full">
            <div class="third left">
              <div class="label">{{ $t('employee.contract.contractType') }}</div>
            </div>
            <div class="twothirds right">
              <div class="label data">{{ contractTypeMap[employeeContract.contractType] }}</div>
            </div>
          </div>
          <div class="full">
            <div class="third left">
              <div class="label">{{ $t('employee.contract.collectiveShort') }}</div>
            </div>
            <div class="twothirds right">
              <div class="label data">{{
                  (employeeContract.collectiveContractId && allowedContractMap) ? (allowedContractMap[employeeContract.collectiveContractId] ? getCollectiveContractName(employeeContract.collectiveContractId) :
                          $t('employee.contract.collectiveNotAllowed'))
                      : $t('employee.contract.noCollective')
                  }}
              </div>
            </div>
          </div>
          <div class="full split-bottom">
            <div class="third left">
              <div class="label">{{ $t('employee.contract.employmentType') }}</div>
            </div>
            <div class="twothirds right">
              <div class="label data">{{ employmentTypeMap[employeeContract.employmentType] }}</div>
            </div>
          </div>
          <div class="full split-bottom">
            <div class="third left">
              <div class="label">{{ $t('employee.contract.pregnancy') }}</div>
            </div>
            <div class="twothirds right">
              <div class="label data">{{ employeeContract.pregnant ? $t('settings.ui.yes') : $t('settings.ui.no') }}</div>
            </div>
          </div>
          <div class="full split-bottom" v-if="employeeContract.accPeriodExclusion">
            <div class="third left">
              <div class="label">{{ $t('employee.contract.exceptionCalculation') }}</div>
            </div>
            <div class="twothirds right">
              <div class="label data">{{ employeeContract.accPeriodExclusion ? $t('settings.ui.yes') : $t('settings.ui.no') }}</div>
            </div>
          </div>

        </div>
        <div class="third mid">
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.employmentGroup') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ employeeContract.employmentGroup }}</div>
            </div>
          </div>
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.contractStart') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ employeeContractEntryDate(employee, employeeContract.storeId, false) }}</div>
            </div>
          </div>
          <div class="full" v-if="hasContractChangeDate">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.changeValidFrom') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ $helpers.extractDateStringTZ(employeeContract.from, 'DD.MM.YYYY') }}</div>
            </div>
          </div>
          <div v-if="employeeContract.probationTo" class="full" v-bind:class="{'split-bottom': !employeeContract.deadlineTo && !employeeContract.to}">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.probationUntil') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ $helpers.extractDateStringTZ(employeeContract.probationTo, 'DD.MM.YYYY') }}</div>
            </div>
          </div>
          <div v-if="employeeContract.deadlineTo" class="full" v-bind:class="{'split-bottom': !employeeContract.to}">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.fixedTermEnd') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ $helpers.getMomentFromStringTZ(employeeContract.deadlineTo).add(-1,'days').format('DD.MM.YYYY') }}</div>
            </div>
          </div>
          <div v-if="employeeContract.to" class="full split-bottom-tight">
            <div class="twothirds left">
              <div class="label">{{ $t('settings.wage.validTo') }}</div>
            </div>
            <div class="third right">
              <div class="label data">
                {{ $helpers.getMomentFromStringTZ(employeeContract.to).add(-1, 'days').format('DD.MM.YYYY') }}
              </div>
            </div>
          </div>
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.weeklyHours') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ minutesToHours(employeeContract.weekTimeRegular) }}</div>
            </div>
          </div>
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.daysPerWeek') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ employeeContract.weekWorkDaysRegular }}</div>
            </div>
          </div>
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.normalWorkdays') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ formatWeekDayArray(employeeContract.workDays) }}</div>
            </div>
          </div>
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.additionalMonthlyHours') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ minutesToHours(employeeContract.additionalMonthWorkTime) }}</div>
            </div>
          </div>
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.overtimeWeeklyLimit') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ minutesToHours(employeeContract.weeklyOvertimeCutoff) }}</div>
            </div>
          </div>
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.overtimeDailyLimit') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ minutesToHours(employeeContract.overtimeCutoff) }}</div>
            </div>
          </div>
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.fulltimeWeeklyLimit') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ minutesToHours(employeeContract.fullTimeCutoff) }}</div>
            </div>
          </div>
          <div class="full">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.fulltimeDailyLimit') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ minutesToHours(employeeContract.dayFullTimeCutoff) }}</div>
            </div>
          </div>
          <div class="full split-bottom">
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.annualVacationDays') }}</div>
            </div>
            <div class="third right">
              <div class="label data">{{ Math.max(0, minutesToDays(employeeContract.vacationTime) + minutesToDays(employeeContract.vacationTimeInc) - minutesToDays(employeeContract.vacationTimeDec)) }}</div>
            </div>
          </div>
        </div>
        <!--<div class="third right">
          <div  class="full">
            <div class="full">
              <div class="half left">
                <div class="label">Dokument vorhanden</div>
              </div>
              <div class="half">
                <div class="button small">
                  <div class="label">
                    Vertragsdokument öffnen
                  </div>
                </div>
              </div>
            </div>
            <div class="full split-bottom-tight">
              <div class="half left">
                <div class="label">Vertrag hochgeladen</div>
              </div>
              <div class="half">
                <div class="label data"></div>
              </div>
            </div>

          </div>

        </div>-->

        <div class="full">
          <div class="third left">
            <div class="full">
              <div class="header">
                <div class="label">{{ $t('employee.contract.payment') }}</div>
              </div>
              <div class="third left">
                <div class="label">{{ $t('employee.contract.payment') }}styp</div>
              </div>
              <div class="twothirds right">
                <div class="label data">{{ paymentTypeMap[employeeContract.paymentType] }}</div>
              </div>
            </div>
            <div class="full" v-if="employeeContract.paymentType == 2">
              <div class="third left">
                <div class="label">{{ $t('employee.contract.paymentType') }}</div>
              </div>
              <div class="twothirds right">
                <div class="label data">{{ wageTypeMap[employeeContract.wageType] }}</div>
              </div>
            </div>
            <div class="full">
              <div class="third left">
                <div class="label">{{ $t('employee.contract.payment') }}</div>
              </div>
              <div class="twothirds right">
                <div class="label data">{{ employeeContract.payment / 100 }}</div>
              </div>
            </div>
            <div class="full" v-if="employeeContract.hasOwnProperty('extraPayment')">
              <div class="third left">
                <div class="label">{{ $t('employee.contract.supplement') }}</div>
              </div>
              <div class="twothirds right">
                <div class="label data">{{ employeeContract.extraPayment / 100 }}</div>
              </div>
            </div>
            <div class="full">
              <div class="third left">
                <div class="label">{{ $t('employee.contract.subsidy') }}</div>
              </div>
              <div class="twothirds right">
                <div class="label data">{{ employeeContract.assistancePayment / 100 }}</div>
              </div>
            </div>
          </div>
          <div class="third mid">
            <div class="full">
              <div class="header">
                <div class="label">{{ $t('employee.contract.overtimeBonuses') }}</div>
              </div>
              <div class="half left">
                <div class="label">{{ $t('employee.contract.bonusPerHour') }}</div>
              </div>
              <div class="half right">
                <div class="label data">{{ employeeContract.overtimeBonusHour / 100 }}</div>
              </div>
            </div>
            <div class="full">
              <div class="half left">
                <div class="label">{{ $t('employee.contract.bonusFlat') }}</div>
              </div>
              <div class="half right">
                <div class="label data">{{ employeeContract.overtimeBonusShift / 100 }}</div>
              </div>
            </div>
          </div>
          <div class="third right" v-if="employeeContract.calculateNightWork">
            <div class="full">
              <div class="header">
                <div class="label">{{ $t('employee.contract.nightworkAndBonuses') }}</div>
              </div>
            </div>
            <div class="full">
              <div class="half left">
                <div class="label">{{ $t('employee.contract.nightworkFrom') }}</div>
              </div>
              <div class="half right">
                <div class="label data">{{ employeeContract.nightWorkFrom }}</div>
              </div>
            </div>
            <div class="full">
              <div class="half left">
                <div class="label">{{ $t('employee.contract.nightworkTo') }}</div>
              </div>
              <div class="half right">
                <div class="label data">{{ employeeContract.nightWorkTo }}</div>
              </div>
            </div>
            <div class="full">
              <div class="half left">
                <div class="label">{{ $t('employee.contract.nightworkCalculation') }}</div>
              </div>
              <div class="half right">
                <div class="label data">{{ nightWorkModeMap[employeeContract.nightWorkMode] }}</div>
              </div>
            </div>
            <div class="full"
                 v-if="employeeContract.nightWorkMode == 1 || employeeContract.nightWorkMode == 4 || employeeContract.nightWorkMode == 5">
              <div class="half left">
                <div class="label">{{ $t('employee.contract.nightworkLimit') }}</div>
              </div>
              <div class="half right">
                <div class="label data">{{ (employeeContract.nightWorkCutoff).toFixed(2) }}%</div>
              </div>
            </div>
            <div class="full"
                 v-if="employeeContract.nightWorkMode == 1 || employeeContract.nightWorkMode == 3 || employeeContract.nightWorkMode == 5">
              <div class="half left">
                <div class="label">{{ $t('employee.contract.bonusPerHour') }}</div>
              </div>
              <div class="half right">
                <div class="label data">{{ employeeContract.nightWorkBonusHour / 100 }}</div>
              </div>
            </div>
            <div class="full"
                 v-if="employeeContract.nightWorkMode == 1 || employeeContract.nightWorkMode == 2 || employeeContract.nightWorkMode == 4">
              <div class="half left">
                <div class="label">{{ $t('employee.contract.bonusFlat') }}</div>
              </div>
              <div class="half right">
                <div class="label data">{{ employeeContract.nightWorkBonusShift / 100 }}</div>
              </div>
            </div>


          </div>
        </div>
        <div class="full" v-if="employeeContract.comment || employeeContract.exitReason">
          <div class="third left">
            <div class="full">
              <div class="header">
                <div class="label">{{ $t('employee.contract.additionalInfo') }}</div>
              </div>
            </div>
            <div class="full" v-if="employeeContract.comment">
              <div class="third left">
                <div class="label">{{ $t('employee.contract.comment') }}</div>
              </div>
              <div class="twothirds right">
                <div class="label data">{{ employeeContract.comment }}</div>
              </div>
            </div>
            <div class="full" v-if="employeeContract.exitReason">
              <div class="third left">
                <div class="label">{{ $t('employee.contract.exitReason') }}</div>
              </div>
              <div class="twothirds right">
                <div class="label data">{{
                    exitReasonMap[employeeContract.exitReason] ? exitReasonMap[employeeContract.exitReason] : employeeContract.exitReason
                  }}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <div v-else class="full split-bottom">
        <div class="twothirds left">
          <div v-if="!futureEmployeeContracts || futureEmployeeContracts.length == 0" class="full">
            <!-- <div class="header">
                <div class="label">Arbeitsvertrag anlegen</div>
                <div class="header-right">
                    <div class="button small right" style="margin-right: 0px;" @click="openNewContractWizard()">
                        <div class="label">
                            Vertrag erstellen
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="full">
              <div class="label">{{ $t('employee.contract.noActiveContract') }}</div>
            </div>
          </div>
          <div v-else class="full">
            <div class="header">
              <div class="label">{{ $t('employee.contract.activeContracts') }}</div>
            </div>
            <div class="twothirds left">
              <div class="label">{{ $t('employee.contract.contractBeginsOn') + ' ' + formattedDate(upcomingContract.from) }}</div>
            </div>
            <div class="third right">
              <div class="button small right" style="margin-right: 0px;" @click="openDetails(upcomingContract)">
                <div class="label">
                  {{ $t('employee.contract.showDetails') }}
                </div>
              </div>
            </div>
          </div>
          <div class="full">
          </div>
        </div>
      </div>
      <div v-if="futureEmployeeContracts != undefined && futureEmployeeContracts.length > 0" class="full">
        <div class="header">
          <div class="label">{{ $t('employee.contract.futureContracts') }}</div>
        </div>
        <b-table class="documents" striped hover :borderless="true" :outlined="false" :items="futureEmployeeContracts"
                 :fields="fieldsFuture">
          <template v-slot:cell(fileId)="row">
            <div style="text-align: left; margin-left: 20px;">
              <i class="fas fa-check-circle checkIcon coredata"
                 v-bind:class="{'true' : row.item.fileId, 'false' : !row.item.fileId}"></i>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="button small mright8" v-on:click="openDetails(row.item)">
              <div class="label">{{ $t('settings.wage.detail') }}</div>
            </div>
<!--            <div class="button small mright8" v-on:click="openEditModal(row.item)">-->
<!--              <div class="label">Bearbeiten</div>-->
<!--            </div>-->
<!--            <div v-if="row.item.fileId" class="button small mright8" v-on:click="loadAndOpenContractFile(row.item)">-->
<!--              <div class="label">Dokument öffnen</div>-->
<!--            </div>-->
<!--            <div v-else class="button small mright8" v-on:click="selectFileForUpload(row.item)">-->
<!--              <div class="label">Dokument hochladen</div>-->
<!--            </div>-->
            <!--<div v-if="(!row.item.approved || !checkApprovalDate(row.item))" class="button small mright8" v-on:click="openApproveContractModal(row.item)">
                <div class="label">Bestätigen</div>
            </div>-->
<!--            <div v-if="row.item.approved && checkApprovalDate(row.item)" class="button small mright8 disabled">-->
<!--              <div class="label">Bestätigt</div>-->
<!--            </div>-->
<!--            <div v-if="!row.item.approved && isLastContract(row.item)" class="button small mright8"-->
<!--                 v-on:click="openDeleteContractModal(row.item)">-->
<!--              <div class="label">Löschen</div>-->
<!--            </div>-->
          </template>
        </b-table>
      </div>
      <div v-if="pastEmployeeContracts != undefined && pastEmployeeContracts.length > 0" class="full">
        <div class="header">
          <div class="label">{{ $t('employee.contract.pastContracts') }}</div>
        </div>
        <b-table class="documents" striped hover :borderless="true" :outlined="false" :items="pastEmployeeContracts"
                 :fields="fieldsPast">
          <template v-slot:cell(fileId)="row">
            <div style="text-align: left; margin-left: 20px;">
              <i class="fas fa-check-circle checkIcon coredata"
                 v-bind:class="{'true' : row.item.fileId, 'false' : !row.item.fileId}"></i>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="button small mright8" v-on:click="openDetails(row.item)">
              <div class="label">{{ $t('settings.wage.detail') }}</div>
            </div>
<!--            <div class="button small mright8" v-on:click="openEditModal(row.item)">-->
<!--              <div class="label">Bearbeiten</div>-->
<!--            </div>-->
<!--            <div v-if="row.item.fileId" class="button small mright8" v-on:click="loadAndOpenContractFile(row.item)">-->
<!--              <div class="label">Dokument öffnen</div>-->
<!--            </div>-->
<!--            <div v-else class="button small mright8" v-on:click="selectFileForUpload(row.item)">-->
<!--              <div class="label">Dokument hochladen</div>-->
<!--            </div>-->
<!--            <div v-if="(!row.item.approved || !checkApprovalDate(row.item))" class="button small mright8"-->
<!--                 v-on:click="openApproveContractModal(row.item)">-->
<!--              <div class="label">Bestätigen</div>-->
<!--            </div>-->
<!--            <div v-if="row.item.approved" class="button small mright8"-->
<!--                 v-on:click="openUnapproveContractModal(row.item)">-->
<!--              <div class="label">Bestätigung aufheben</div>-->
<!--            </div>-->
<!--            <div v-if="!row.item.approved && isLastContract(row.item)" class="button small mright8"-->
<!--                 v-on:click="openDeleteContractModal(row.item)">-->
<!--              <div class="label">Löschen</div>-->
<!--            </div>-->
          </template>
        </b-table>
      </div>
    </div>

    <b-modal size="contractdetails" ref="modal-contractdetails" centered :hide-header="true" :hide-footer="true">
      <div class="wizard-popup">
        <b-row>
          <b-col>
            <div class="header main" style="background: none">
              <div class="label">{{ $t('employee.contract.contractDetails') }}</div>
            </div>
            <div class="close" v-on:click="hideModal('modal-contractdetails');">
              <i class="fas fa-times"></i>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="detailContract">
          <b-col style="margin-top: 40px">
            <div class="full split-bottom" v-if="parentContract(detailContract) != null">
              <div class="header">
                <div class="label">{{ $t('employee.contract.contractChange') }}</div>
              </div>
              <div class="twothirds left">
                  <div class="label">
                      {{ $t('employee.contract.continuesContractValidSince') + ' ' + $helpers.extractDateStringTZ(parentContract(detailContract).from, 'DD.MM.YYYY') }}
                  </div>
              </div>
              <div class="third">
                <div class="button small" @click="openDetails(parentContract(detailContract))">
                  <div class="label">
                    {{ $t('employee.contract.showContract') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="full split-bottom" v-if="childContract(detailContract) != null">
              <div class="header">
                <div class="label">{{ $t('employee.contract.contractChange') }}</div>
              </div>
              <div class="twothirds left">
                  <div class="label">
                      {{ $t('employee.contract.replacedByContractChangeFrom') + ' ' + $helpers.extractDateStringTZ(childContract(detailContract).from, 'DD.MM.YYYY') }}
                  </div>
              </div>
              <div class="third">
                <div class="button small" @click="openDetails(childContract(detailContract))">
                  <div class="label">
                    {{ $t('employee.contract.showContract') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="full split-bottom">
              <div class="half left">
                <div class="header">
                  <div class="label">{{ $t('employee.contract.contract') }}</div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.job') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.jobName }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.employmentGroup') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.employmentGroup }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.category') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ employeeCategoryMap[detailContract.employeeCategory] }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.contractType') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ contractTypeMap[detailContract.contractType] }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.employmentType') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ employmentTypeMap[detailContract.employmentType] }}</div>
                  </div>
                </div>
                <div class="full split-bottom">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.pregnancy') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.pregnant ? $t('settings.ui.yes') : $t('settings.ui.no') }}</div>
                  </div>
                </div>
                <div class="full split-bottom">
                    <div class="half left">
                        <div class="label">{{ $t('employee.contract.exceptionCalculation') }}</div>
                    </div>
                    <div class="half right">
                        <div class="label data">{{ detailContract.accPeriodExclusion ? $t('settings.ui.yes') : $t('settings.ui.no') }}</div>
                    </div>
                </div>
                <div class="full" v-bind:class="{'split-bottom': !detailContract.costCenterId}">
                  <div class="half left">
                    <div class="label">{{ $t('comp.ui.store') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ getStoreInfoString(detailContract.storeId) }}</div>
                  </div>
                </div>
                <div v-if="detailContract.costCenterId" class="full split-bottom">
                  <div class="half left">
                    <div class="label">{{ $t('comp.ui.costCenter') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ getCostCenterInfoString(detailContract.costCenterId) }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.validFrom') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ $helpers.extractDateStringTZ(detailContract.from, 'DD.MM.YYYY') }}</div>
                  </div>
                </div>
                <div v-if="detailContract.probationTo" class="full" v-bind:class="{'split-bottom': !detailContract.to && !detailContract.deadlineTo}">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.probationUntil') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ $helpers.getMomentFromStringTZ(detailContract.probationTo).add(-1,'days').format('DD.MM.YYYY') }}</div>
                  </div>
                </div>
                <div v-if="detailContract.deadlineTo" class="full" v-bind:class="{'split-bottom': !detailContract.to}">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.fixedTermEnd') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ $helpers.getMomentFromStringTZ(detailContract.deadlineTo).add(-1,'days').format('DD.MM.YYYY') }}</div>
                  </div>
                </div>
                <div v-if="detailContract.to" class="full split-bottom-tight">
                  <div class="half left">
                    <div class="label">{{ $t('settings.wage.validTo') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ $helpers.getMomentFromStringTZ(detailContract.to).add(-1,'days').format('DD.MM.YYYY') }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.weeklyHours') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ minutesToHours(detailContract.weekTimeRegular) }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.additionalMonthlyHours') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ minutesToHours(detailContract.additionalMonthWorkTime) }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.daysPerWeek') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.weekWorkDaysRegular }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.normalWorkdays') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ formatWeekDayArray(detailContract.workDays) }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.overtimeWeeklyLimit') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ minutesToHours(detailContract.weeklyOvertimeCutoff) }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.overtimeDailyLimit') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ minutesToHours(detailContract.overtimeCutoff) }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.fulltimeWeeklyLimit') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ minutesToHours(detailContract.fullTimeCutoff) }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.fulltimeDailyLimit') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ minutesToHours(detailContract.dayFullTimeCutoff) }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.annualVacationDays') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ minutesToDays(detailContract.vacationTime) }}</div>
                  </div>
                </div>
                <div class="full" v-if="detailContract.vacationTimeInc">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.vacationIncrease') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ minutesToDays(detailContract.vacationTimeInc) }}</div>
                  </div>
                </div>
                <div class="full" v-if="detailContract.vacationTimeDec">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.vacationReduction') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ minutesToDays(detailContract.vacationTimeDec) }}</div>
                  </div>
                </div>
              </div>
              <div class="half">
                <div class="full">
                  <div class="header">
                    <div class="label">{{ $t('employee.contract.payment') }}</div>
                  </div>
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.payment') }}styp</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ paymentTypeMap[detailContract.paymentType] }}</div>
                  </div>
                </div>
                <div class="full" v-if="detailContract.paymentType == 2">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.paymentType') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ wageTypeMap[detailContract.wageType] }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.payment') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.payment / 100 }}</div>
                  </div>
                </div>
                <div class="full" v-if="detailContract.hasOwnProperty('extraPayment')">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.supplement') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.extraPayment / 100 }}</div>
                  </div>
                </div>
                <div class="full split-bottom">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.subsidy') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.assistancePayment / 100 }}</div>
                  </div>
                </div>
                <div class="full">
                  <div class="header">
                    <div class="label">{{ $t('employee.contract.overtimeBonuses') }}</div>
                  </div>
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.bonusPerHour') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.overtimeBonusHour /100 }}</div>
                  </div>
                </div>
                <div class="full split-bottom">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.bonusFlat') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.overtimeBonusShift/100 }}</div>
                  </div>
                </div>
                <div class="full" v-if="detailContract.calculateNightWork">
                  <div class="header">
                    <div class="label">{{ $t('employee.contract.nightworkAndBonuses') }}</div>
                  </div>
                </div>

                <div class="full" v-if="detailContract.calculateNightWork">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.nightworkFrom') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.nightWorkFrom }}</div>
                  </div>
                </div>
                <div class="full" v-if="detailContract.calculateNightWork">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.nightworkTo') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.nightWorkTo }}</div>
                  </div>
                </div>
                <div class="full" v-if="detailContract.calculateNightWork && (detailContract.nightWorkMode == 1 || detailContract.nightWorkMode == 3 || detailContract.nightWorkMode == 5 )">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.bonusPerHour') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.nightWorkBonusHour/100 }}</div>
                  </div>
                </div>
                <div class="full" v-if="detailContract.calculateNightWork && (detailContract.nightWorkMode == 1 || detailContract.nightWorkMode == 2 || detailContract.nightWorkMode == 4 )">
                  <div class="half left">
                    <div class="label">{{ $t('employee.contract.bonusFlat') }}</div>
                  </div>
                  <div class="half right">
                    <div class="label data">{{ detailContract.nightWorkBonusShift/100 }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="full" v-if="detailContract.comment || detailContract.exitReason">
              <div class="header">
                <div class="label">{{ $t('employee.contract.additionalInfo') }}</div>
              </div>
              <div class="third left">
                <div class="label">{{ $t('employee.contract.comment') }}</div>
              </div>
              <div class="twothirds right">
                <div class="label data">{{detailContract.comment }}</div>
              </div>
              <div class="third left">
                <div class="label">{{ $t('employee.contract.exitReason') }}</div>
              </div>
              <div class="twothirds right">
                <div class="label data">{{exitReasonMap[detailContract.exitReason] ? exitReasonMap[detailContract.exitReason] : detailContract.exitReason }}</div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
  <!--
                          <table class="table">
                              <tr>
                                  <th>Store ID</th>
                                  <th>Job</th>
                                  <th>Tage pro Woche</th>
                                  <th>Stunden pro Woche</th>
                                  <th>Start</th>
                                  <th>Ende</th>
                                  <th>Bezahlung</th>
                                  <th>Urlaubstage</th>
                              </tr>

                              <tr v-for="(item, index) in contracts">
                                  <td>{{ item.storeId}}</td>
                                  <td>{{ item.jobName}}</td>
                                  <td>{{ item.weekWorkDaysRegular}}</td>
                                  <td>{{ (item.weekTimeRegular / 60) }}</td>
                                  <td>{{ item.from}}</td>
                                  <td>{{ item.to}}</td>
                                  <td>{{ (item.payment/100)}} €</td>
                                  <td>{{ (item.vacationTime/60/24)}}</td>
                              </tr>
                          </table>
                      </div>-->
</template>


<script>
import {
  mapState,
  mapGetters
} from 'vuex';
import button from '../uicomponents/button.vue';

export default {
  components: {button},
  name: 'employeecontracts',
  data() {
    return {
      loading: true,
      detailContract: null,
      selectedContractStoreId: null,
    }
  },
  created: function () {
    //console.log("CREATED");
  },
  mounted: function () {
    console.log("MOUNTED");
    if (this.$store.state.jwt != undefined && this.$store.state.companyId != undefined) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters(['companyId', 'isSuperUser', 'externalServicesMap', 'storeSettings', 'uiDataMap', 'costCenterArray']),
    employeeContract: {
      get: function () {
        return this.currentContractsForEmployee(this.employee)[this.selectedContractStoreId];
      }
    },
    pastEmployeeContracts: {
      get: function () {
        return this.employeeContractsForEmployeeWithType(this.employee, 0);
      }
    },
    futureEmployeeContracts: {
      get: function () {
        return this.employeeContractsForEmployeeWithType(this.employee, 2);
      }
    },
    currentEmployeeContractStores: {
      get: function () {
        return Object.keys(this.currentContractsForEmployee(this.employee));
      }
    },
    hasContractChangeDate: function (){
      let currentEntry = this.employeeContractEntryDate(this.employee, this.employeeContract.storeId, false);
      let currentContractFrom = this.$helpers.getMomentFromStringTZ(this.employeeContract.from);
      return currentEntry != currentContractFrom.format('DD.MM.YYYY');
    },
    dateDisplay: function () {
      return this.$helpers.getMomentTZ().format('YYYY-MM-DD');
    },
    headerButtons() {
      let view = this;

      let state = {
        buttons: []
      };

      return state;
    },
    timeZoneList() {
      let result = [];
      /*
      this.timeZones.forEach(i => {
          let item = {label: i, value: i};
          result.push(item);
      })
      */
      return result;
    },
    upcomingContract: {
      get: function () {
        var val;
        for (var i = 0; i < this.futureEmployeeContracts.length; i++) {
          var cur = this.futureEmployeeContracts[i];
          if (!val) {
            val = cur;
          } else {
            let valDate = new Date(val.from);
            let curDate = new Date(cur.from);
            if (curDate < valDate) val = cur;
          }
        }
        return val;
      }
    },
    employeeCategoryMap() {
      if (this.uiData == undefined || this.uiData.employeeCategories == undefined) {
        return {};
      } else {
        return this.uiData.employeeCategories.reduce((map, obj) => {
          map[obj.id] = this.$t(`enum.employeeCategory.${obj.id}`);
          return map;
        }, {});
      }
    },
    contractTypeMap() {
      if (this.uiData == undefined || this.uiData.contractTypes == undefined) {
        return {};
      } else {
        return this.uiData.contractTypes.reduce((map, obj) => {
          map[obj.id] = this.$t(`enum.contractType.${obj.id}`);
          return map;
        }, {});
      }
    },
    employmentTypeMap() {
      if (this.uiData == undefined || this.uiData.employmentTypes == undefined) {
        return {};
      } else {
        return this.uiData.employmentTypes.reduce((map, obj) => {
          map[obj.id] = this.$t(`enum.employmentType.${obj.id}`);
          return map;
        }, {});
      }
    },
    paymentTypeMap() {
      if (this.uiData == undefined || this.uiData.paymentTypes == undefined) {
        return {};
      } else {
        return this.uiData.paymentTypes.reduce((map, obj) => {
          map[obj.id] = this.$t(`enum.paymentType.${obj.id}`);
          return map;
        }, {});
      }
    },
    wageTypeMap() {
      if (this.uiData == undefined || this.uiData.wageTypes == undefined) {
        return {};
      } else {
        return this.uiData.wageTypes.reduce((map, obj) => {
          map[obj.id] = this.$t(`enum.wageType.${obj.id}`);
          return map;
        }, {});
      }
    },
    nightWorkerTypeMap() {
      if (this.uiData == undefined || this.uiData.nightWorkerTypes == undefined) {
        return {};
      } else {
        return this.uiData.nightWorkerTypes.reduce((map, obj) => {
          map[obj.id] = this.$t(`enum.nightWorkerType.${obj.id}`);
          return map;
        }, {});
      }
    },
    nightWorkModeMap() {
      if (this.uiData == undefined || this.uiData.nightWorkModes == undefined) {
        return {};
      } else {
        return this.uiData.nightWorkModes.reduce((map, obj) => {
          map[obj.id] = this.$t(`enum.bonusMode.${obj.id}`);
          return map;
        }, {});
      }
    },
    exitReasonMap() {
      if (this.uiData == undefined || this.uiData.exitReasons == undefined) {
        return {};
      } else {
        return this.uiData.exitReasons.reduce((map, obj) => {
          map[obj.id] = this.$t(`enum.exitReason.${obj.id}`);
          return map;
        }, {});
      }
    },
    fieldsPast() {
      return [
        {
          key: "icon",
          label: "",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd fileIconRed'
        }, {
          key: "jobName",
          label: this.$t('employee.contract.job'),
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }, {
          key: "weekTimeRegular",
          label: this.$t('employee.contract.weeklyHours'),
          formatter: "formattedWeekTime",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }, {
          key: "storeId",
          label: this.$t('employee.contract.store'),
          formatter: "formatStoreId",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }, {
          key: "from",
          label: this.$t('employee.contract.contractStart'),
          formatter: "formattedDate",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }, {
          key: "to",
          label: this.$t('employee.contract.contractEnd'),
          formatter: "formattedEndDate",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        // }, {
        //   key: "fileId",
        //   label: "Dokument",
        //   sortable: false,
        //   thClass: 'documentsTh',
        //   tdClass: 'documentsTd'
        }, {
          key: "actions",
          label: "",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }
      ]
    },
    fieldsFuture() {
      return [
        {
          key: "icon",
          label: "",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd fileIconPlus'
        }, {
          key: "jobName",
          label: this.$t('employee.contract.job'),
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }, {
          key: "weekTimeRegular",
          label: this.$t('employee.contract.weeklyHours'),
          formatter: "formattedWeekTime",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }, {
          key: "storeId",
          label: this.$t('employee.contract.store'),
          formatter: "formatStoreId",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }, {
          key: "from",
          label: this.$t('employee.contract.contractStart'),
          formatter: "formattedDate",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }, {
          key: "to",
          label: this.$t('employee.contract.contractEnd'),
          formatter: "formattedEndDate",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        // }, {
        //   key: "fileId",
        //   label: "Dokument",
        //   sortable: false,
        //   thClass: 'documentsTh',
        //   tdClass: 'documentsTd'
        }, {
          key: "actions",
          label: "",
          sortable: false,
          thClass: 'documentsTh',
          tdClass: 'documentsTd'
        }
      ]
    },
  },
  watch: {
    storeId: function (val, oldVal) {
      this.refresh();
    },
    employee: function (val, oldVal) {
      this.loading = true;
      this.refresh();
    },
    contracts: function (val, oldVal) {
      this.refresh();
    }
  },
  props: [
    "employee",
    "uiData",
    "collectiveContractMap",
    "allowedContractMap",
    "contracts",
    "stores"
  ],
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      this.loading = true;
      let view = this;

      let currentContracts = this.currentContractsForEmployee(this.employee);
      let oldestContract = null;
      let oldestContractFrom = null;
      let currentContractStoreIds = Object.keys(currentContracts);
      for (let i = 0; i < currentContractStoreIds.length; i++) {
        let currentContract = currentContracts[currentContractStoreIds[i]];
        let currentContractFrom = this.$helpers.getMomentFromStringTZ(currentContract.from);
        if (!oldestContract || currentContractFrom.isBefore(oldestContractFrom)) {
          oldestContract = currentContract;
          oldestContractFrom = currentContractFrom;
        }
      }
      view.selectedContractStoreId = oldestContract ? oldestContract.storeId : null;

      view.loading = false;
    },
    formattedDate(str) {
      return str ? this.$helpers.getMomentFromStringTZ(str).format("DD.MM.YYYY") : '-';
    },
    formattedEndDate(str) {
      return str ? this.$helpers.getMomentFromStringTZ(str).add(-1, 'days').format("DD.MM.YYYY") : '-';
    },
    formattedWeekTime(mins) {
      return (mins / 60) + " " + this.$t('employee.contract.hours')
    },
    formatWeekDayArray(array){
      let result = "";
      if(array){
        array.forEach(e => {
          if(e == 1){result+=this.$t('global.time.mo') + " "}
          else if(e == 2){result+=this.$t('global.time.tu') + " "}
          else if(e == 3){result+=this.$t('global.time.we') + " "}
          else if(e == 4){result+=this.$t('global.time.th') + " "}
          else if(e == 5){result+=this.$t('global.time.fr') + " "}
          else if(e == 6){result+=this.$t('global.time.sa') + " "}
          else if(e == 7){result+=this.$t('global.time.su') + " "}
        })
      }
      return result;
    },
    formatStoreId(storeId){
      let store = this.stores.find(s => s.id == storeId);
      if(store){
        return store.name;
      } else {
        return storeId;
      }
    },
    openDetails(c) {
      this.detailContract = c;
      this.showModal('modal-contractdetails');
    },
    contractWithId(contractId) {
      if (this.employeeContract && this.employeeContract.id == contractId) return this.employeeContract;
      var allContracts = this.pastEmployeeContracts.concat(this.futureEmployeeContracts);
      for (var i = 0; i < allContracts.length; i++) {
        if (allContracts[i].id == contractId) return allContracts[i];
      }
      return null;
    },
    parentContract(contract) {
      if (contract.parentId) return this.contractWithId(contract.parentId);
    },
    childContract(contract) {
      var parentId = contract.id;
      if (this.employeeContract && this.employeeContract.parentId == parentId) return this.employeeContract;
      var allContracts = this.pastEmployeeContracts.concat(this.futureEmployeeContracts);
      for (var i = 0; i < allContracts.length; i++) {
        var cur = allContracts[i];
        if (cur && cur.parentId == parentId) return cur;
      }
      return null;
    },
    employeeContractEntryDate(employee, storeId, first) {
      var firstFrom = '';
      if (employee.workEntryDate != null && first) {
        firstFrom = this.$helpers.getMomentFromStringTZ(employee.workEntryDate).format('DD.MM.YYYY');
      } else {
        var contracts = this.currentContractsForEmployee(employee);
        var contract = contracts[storeId];
        var pastContracts = this.employeeContractsForEmployeeWithType(employee, 0, storeId);
        var futureContracts = this.employeeContractsForEmployeeWithType(employee, 2, storeId);


        if (contract != null) {
          firstFrom = this.$helpers.extractDateStringTZ(contract.from, 'DD.MM.YYYY');
        }
        var d;
        pastContracts.forEach((pc) => {
          var curFrom = this.$helpers.getMomentFromStringTZ(pc.from);
          if (d == null || curFrom < d) d = curFrom;
        });
        if (d != null) firstFrom = d.format('DD.MM.YYYY');
        if (first) {
          return firstFrom;
        } else {
          var from = '';

          let c = contract;
          if (c == null && futureContracts.length > 0) {
            var nextFrom;
            futureContracts.forEach((fc) => {
              var curFrom = this.$helpers.getMomentFromStringTZ(fc.from);
              if (nextFrom == null) {
                nextFrom = curFrom;
                c = fc;
              } else {
                if (curFrom < nextFrom) {
                  nextFrom = curFrom;
                  c = fc;
                }
              }
            });
          }
          if (c != null) {
            from = this.$helpers.getMomentFromStringTZ(c.from);
            let preceeding = this.getPreceedingContract(c, pastContracts);
            while (preceeding != null) {
              from = this.$helpers.getMomentFromStringTZ(preceeding.from);
              c = preceeding;
              preceeding = this.getPreceedingContract(c, pastContracts);
            }

            return from.format('DD.MM.YYYY');
          }
        }
      }

      return firstFrom;
    },
    getPreceedingContract(contract, otherContracts) {
      let from = this.$helpers.getMomentFromStringTZ(contract.from);
      let prec;
      otherContracts.forEach((pc) => {
        let to = this.$helpers.getMomentFromStringTZ(pc.to);
        let diff = this.$helpers.TimeDiff(from, to);
        if (diff == 0) {
          prec = pc;
        }
      });
      return prec;
    },
    currentContractsForEmployee(employee) {
      var contracts = {};
      var keys = this.contracts !== undefined ? Object.keys(this.contracts) : [];
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (this.contracts[key].remoteId == employee.id) {
          if (this.contractType(this.contracts[key]) == 1) {
            contracts[this.contracts[key].storeId] = this.contracts[key];
          }
        }
      }
      return contracts;
    },
    contractType(c) {
      var now = new Date();
      let fromDate = new Date(c.from);
      if (c.to) {
        let toDate = new Date(c.to);
        if (toDate < now) {
          return 0;
        }
      }
      if (fromDate < now) return 1;
      if (fromDate > now) return 2;
      return -1;
    },
    employeeContractsForEmployeeWithType(employee, type, storeId = null) {
      var c = [];
      var keys = this.contracts !== undefined ? Object.keys(this.contracts) : [];
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (this.contracts[key].remoteId == employee.id) {
          let contract = this.contracts[key];
          if (storeId === null || contract.storeId === storeId) {
            if (this.contractType(contract) == type) c.push(contract);
          }
        }
      }
      return c;
    },
    getCollectiveContractName(id) {
      let allowedContract = this.allowedContractMap[id];
      let collectiveContract = this.collectiveContractMap[allowedContract.collectiveContractId];
      let name = collectiveContract.name + " " + (allowedContract.weekTimeRegular / 60).toFixed(2) + "h / " + allowedContract.weekWorkDaysRegular + "T";
      if (allowedContract.additionalMonthWorkTime > 0) {
        name += " " + (allowedContract.additionalMonthWorkTime / 60).toFixed(2) + " ZS";
      }
      return name;
    },
    minutesToHours(minutes) {
      return minutes / 60;
    },
    minutesToDays(minutes) {
      return minutes / 60 / 24;
    },
    getStoreInfoString(storeId) {
      let view = this;
      let store = view.stores.find((s) => s.id === storeId);
      if (store === null || store === undefined) {
        return view.$t('employee.contract.unauthorizedCostCenter');
      }
      return store.name + (store.description ? ' / ' + store.description : '');
    },
    getCostCenterInfoString(costCenterId) {
      let view = this;
      let costCenter = view.costCenterArray.find((c) => c.id === costCenterId);
      if (costCenter === null || costCenter === undefined) {
        return view.$t('employee.contract.unauthorizedCostCenter');
      }
      return costCenter.name;
    },
    hideModal(ref) {
      this.$refs[ref].hide()
    },
    showModal(ref) {
      this.$refs[ref].show()
    },

  },

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->

<style scoped>
a {
  color: var(--ml);
  cursor: pointer !important;
}

a:hover {
  color: var(--contrast-4);
  cursor: pointer !important;
}
</style>
